<template>
  <ALink
    v-editable="blok"
    class="relative grid card-rounded overflow-hidden shadow-card effect-hover-tilt group"
    ref="cardRef"
    :style="{
      '--rotate-x': `${tilt.x}deg`,
      '--rotate-y': `${tilt.y}deg`,
    }"
    :to="blok.link">
    <div
      v-if="blok.media.length"
      class="col-start-1 row-start-1 clamp-h-70-120 effect-hover-tilt-media">
      <ElementMedia
        :bloks="blok.media"
        :ratio="{ w: 1, h: 1 }"
        :sizes="sizes"
        class="w-full h-full object-cover" />
    </div>
    <ElementSpotlightCardText
      :blok="blok"
      :tintOpacity="tintOpacity"
      class="relative col-start-1 row-start-1" />
  </ALink>
</template>

<script setup lang="ts">
import { ElementSpotlightCardStoryblok } from "@/types";
import { ImgSizes } from "@/components/atoms/AImage.vue";
import useHoverTilt from "@/composables/useHoverTilt";

interface Props {
  blok: ElementSpotlightCardStoryblok;
  sizes: ImgSizes;
  tintOpacity?: number;
}
defineProps<Props>();

const cardRef = ref<HTMLElement | null>(null);
const { tilt } = useHoverTilt(cardRef);
</script>
